import React from 'react';
import { createPortal } from 'react-dom';
import {
  Button,
  IconType,
} from 'ui-builder';
import { useCreateDocumentForm } from 'features/tasks-forms';

export function CreateDocumentButtonPortal() {
  return (
    <span id="create-document-button" />
  );
}

export default function CreateDocumentButton(props: {
  projectId: number,
}) {
  const portal = document.getElementById('create-document-button');

  const createDocumentForm = useCreateDocumentForm();

  if (createDocumentForm.isGranted() && portal) {
    return createPortal(
      <Button
        text="Upload Document"
        iconType={IconType.PLUS}
        onClick={() => {
          createDocumentForm.openForm(props.projectId)
        }}
      />,
      portal,
    );
  } else {
    return null;
  }
}
